<template>
    <CodiceFeanorView tool-module="timing" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
